export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7155.33b20ec9.jpg";